export const getFilenameFromContentDisposition = (
  contentDisposition: string | null | undefined
): string | null | undefined => {
  if (!contentDisposition) {
    return null
  }

  // Handle different content-disposition formats:
  // attachment; filename="filename.pdf"
  // attachment; filename=filename.pdf
  // attachment; filename*=UTF-8''filename%20with%20spaces.pdf
  // attachment; filename="simple.pdf"; filename*=UTF-8''encoded%20filename.pdf

  let filename = null

  // Try to extract filename* (RFC 5987 - UTF-8 encoded) first
  const encodedMatch = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i)
  if (encodedMatch) {
    try {
      filename = decodeURIComponent(encodedMatch[1])
    } catch (e) {
      console.warn('Failed to decode filename:', e)
    }
  }

  // If no encoded filename found, try regular filename
  if (!filename) {
    const regularMatch = contentDisposition.match(/filename\s*=\s*"?([^";]+)"?/i)
    if (regularMatch) {
      filename = regularMatch[1].trim()
      // Remove surrounding quotes if present
      filename = filename.replace(/^["']|["']$/g, '')
    }
  }

  return filename
}
